import { render, staticRenderFns } from "./breadcrumbs.vue?vue&type=template&id=62d37f0c"
import script from "./breadcrumbs.vue?vue&type=script&lang=ts"
export * from "./breadcrumbs.vue?vue&type=script&lang=ts"
import style0 from "./breadcrumbs.vue?vue&type=style&index=0&id=62d37f0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports